import * as React from 'react';

var _path, _path2, _path3, _path4, _path5;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgGooglePay = function SvgGooglePay(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#3C4043",
        fillRule: "evenodd",
        d: "M9.224 12.324V9.907h1.248a1.8 1.8 0 0 0 1.294-.509l.084-.085c.643-.7.6-1.79-.084-2.436a1.78 1.78 0 0 0-1.294-.519H8.469v5.966zm0-3.15V7.092h1.267c.272 0 .53.105.722.295.408.4.417 1.066.023 1.48a.98.98 0 0 1-.745.309zm6.148-.613q-.485-.451-1.322-.452-1.078.001-1.614.794l.666.424q.366-.543 1-.542c.266 0 .524.1.726.28a.9.9 0 0 1 .31.68v.177c-.291-.162-.657-.248-1.107-.248q-.79-.001-1.262.376a1.23 1.23 0 0 0-.473 1.009c-.01.385.154.751.445.999.296.266.67.4 1.111.4.521 0 .934-.234 1.248-.7h.033v.566h.722V9.807q0-.794-.483-1.246m-2.05 3.011a.62.62 0 0 1-.248-.5q.001-.334.305-.556.31-.222.77-.223.632-.006.984.28 0 .485-.375.842c-.225.229-.53.357-.849.357a.9.9 0 0 1-.586-.2m4.155 2.546L20 8.242h-.82l-1.168 2.93h-.014l-1.196-2.93h-.82l1.655 3.82-.938 2.056z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#4285F4",
        d: "M6.618 9.384q0-.35-.057-.695H3.377v1.318h1.825a1.59 1.59 0 0 1-.676 1.042v.857h1.088c.638-.595 1.004-1.475 1.004-2.522"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#34A853",
        d: "M3.377 12.733c.91 0 1.68-.304 2.237-.828l-1.088-.856c-.304.21-.694.328-1.149.328-.881 0-1.627-.604-1.894-1.413H.363v.885a3.37 3.37 0 0 0 3.014 1.884"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FBBC04",
        d: "M1.483 9.964a2.1 2.1 0 0 1 0-1.313v-.88H.363a3.44 3.44 0 0 0 0 3.074z"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#EA4335",
        d: "M3.377 7.238c.483-.01.948.176 1.295.514l.966-.98c-.615-.58-1.421-.899-2.26-.89a3.37 3.37 0 0 0-3.016 1.89l1.121.884c.267-.813 1.013-1.418 1.894-1.418"
    })));
};

export { SvgGooglePay as ReactComponent };
//# sourceMappingURL=GooglePay.svg.es.js.map
